var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === _vm.types.DEFAULT)?_c('FrDashboard'):_vm._e(),(_vm.type === _vm.types.GOVERNANCE)?_c('FrGovDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }